import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, X } from 'lucide-react';
import { ANNOUNCEMENT } from './homeConstants';
import { useDemoProfile } from '../../hooks/useDemoProfile';

export default function AnnouncementBanner({ onDismiss }) {
  const { profile, isDemo } = useDemoProfile();
  const a = (isDemo && profile?.home_announcement?.text)
    ? profile.home_announcement
    : ANNOUNCEMENT;
  return (
    <div className="rounded-xl px-4 py-2.5 flex items-center gap-3 text-[11px]"
         style={{ background: 'linear-gradient(90deg, rgba(0,212,255,0.08), rgba(255,107,189,0.05))', border: '1px solid rgba(0,212,255,0.2)' }}
         data-testid="announcement-banner">
      <Sparkles className="h-3.5 w-3.5 text-[#00D4FF] flex-shrink-0" />
      <span className="text-gray-300 flex-1">{a.text}</span>
      <Link to={a.to} className="text-[#00D4FF] font-bold hover:underline" data-testid="announcement-cta">
        {a.cta} →
      </Link>
      <button onClick={onDismiss} className="text-gray-500 hover:text-white ml-1" data-testid="announcement-dismiss" aria-label="Dismiss">
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
